import { PaymentSuccessPage } from "@/interface/pages/subscriptions/payment-success-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users/subscription/success")({
  component: PaymentSuccessPage,
});
